module.exports = __webpack_public_path__ + "static/media/fotogalereya16.4c01369d.jpg";